/* ==========================================================================
   TNF CATALOGUE geometry adapter 1.5.0                          2026-09-26
   --------------------------------------------------------------------------
   1.5.0 (Jack, 26 Sep 2026). 1.4.0 is not used: a different file of that
   number was written to the preview by a ChatGPT working build on 25 Sep.
   - GRADE P - priced from the product's own size records. "I approve using
     each product's existing size-and-price records as the basis for a
     continuous retail pricing model where its tube measurement remains
     uncertain ... This is an authorised retail pricing policy, not proof of a
     physical tube measurement." A grade P design carries pricing.basis
     'records' (each market's recorded widths and prices) and a cost-model
     estimate (costModel_m_at_ref) that the engine uses ONLY for the growth
     above the largest recorded size and for the outdoor ratio. It is never
     reported as a measured tube length: tubing.model says so, and there is no
     measurement block. The packing plan is the same for every grade.
   - 240 cm LIMIT on width AND height ("Neither width nor height may exceed
     240 cm"): a board taller than 240 cm is refused (above_product_maximum).
     The offered width range comes from the size model's limits() (1.4.0), so
     the page and the order service never offer one; this is the backstop.
   Nothing else changed.
   --------------------------------------------------------------------------
   1.3.0 (25 Sep 2026, afternoon - Jack: "Bulls 23 being two parts only from
   111-121 cm does not meet my instruction for signs requiring splitting below
   150 cm ... if it is an assumption, do not use it to override my
   instruction"): the 120 cm limit is withdrawn from the plan. Its only source
   is a customer email of 13 Aug 2024 ("The largest sign we would be able to
   cut in one piece would be 120cm in length"); it was never confirmed by the
   manufacturer for these signs, and the manufacturer's rule of 23 Sep 2026
   ("If the board size is under 150 cm, two pieces can be packed together")
   has no such condition. So now:
       one      both sides within 110 cm (the creator's one-piece allowance)
       two      it needs splitting and its LONGEST side is under 150 cm: two
                pieces, cut across the longer side (each half is
                longest / 2 x shortest), packed together in one package
       sections 150 cm and over: the creator's grid, ceil(W / 110) across x
                ceil(H / 110) down
   Nothing else changed. (The 1.2.0 description below is kept for history;
   its 120 cm condition no longer applies.)
   --------------------------------------------------------------------------
   1.2.0 (25 Sep 2026, completion brief 2):
   - ONE PACKING PLAN, the creator's approach (Jack, 25 Sep: "where a sign
     needs splitting and is under 1.5 metres, it should be supplied in TWO
     parts. Smaller signs that fit the creator's one-piece allowance remain
     one piece ... Do not introduce a separate grid that automatically turns
     catalogue signs into four or more pieces because of their proportions
     ... Do not promise a physically unsupported cut simply to make the
     numbers match"). parts = catalogueParts(board W, board H):
       one      both sides within 110 cm - the creator's one-piece allowance
                (maxOnePiece_mm 1100, the live creator's notice).
       two      it needs splitting, its LONGEST side is under 150 cm and each
                half fits the 120 cm machine limit: cut across the longer
                side into two pieces. 150 cm is the manufacturer's rule
                (23 Sep 2026: "If the board size is under 150 cm, two pieces
                can be packed together"). 120 cm is the machine limit Jack gave
                on 13 Aug 2024 (engine packing.maxOnePieceSource); it is a
                PROVISIONAL physical limit, so a half longer than 120 cm is
                never promised - such a sign is planned in sections instead.
       sections anything else: the creator's own grid, ceil(W / 110 cm)
                across x ceil(H / 110 cm) down, every section within the
                one-piece allowance. (The creator caps rows at 4; its signs
                never reach 440 cm tall. A catalogue design can, and a cap
                there would promise sections taller than the machine limit,
                so the grid is not capped.)
     The customer is told exactly what the creator tells its customers
     (tnf-creator-2-5-10 packingWording): 'two' -> "Your sign will be made
     in two sections for delivery. These sections can be packed together in
     one package." Every other divided sign -> "Your sign will be made in
     sections for delivery." - no count, because the manufacturer's rule
     covers neither three-or-more pieces nor boards of 150 cm and over.
     The engine prices the carton from THIS plan (policy 'catalogue-2',
     tnf-pricing-2-6-8.js), and the page, the order service, the cart line,
     the email and the factory record all read it, so they cannot disagree.
     1.1.0's width-only rule (over 110 cm wide = two parts, over 220 cm =
     multiple) is withdrawn: it said "two parts" for signs the engine cut in
     four (Bulls 23 at 120 cm: 120 x 118 cm). Now: two pieces of 60 x 118 cm.
   - Grade E is eligible: an image-derived estimate from a MANUALLY CORRECTED
     trace (m4 review, 25 Sep 2026: printed artwork, glow edges and room
     objects removed by a reviewer, every decision recorded). Like A, B and R
     it is an estimate, never manufacturer-verified.
   - Pinned engine tnf-pricing-2-6-8.js, hardwarePolicy 'catalogue-2'.
   ==========================================================================
   (1.1.0 header follows)
   TNF CATALOGUE geometry adapter 1.1.0                          2026-09-25
   --------------------------------------------------------------------------
   1.1.0 (25 Sep 2026, master completion brief):
   - Pinned engine tnf-pricing-2-6-7.js. Every geometry carries
     hardwarePolicy: 'catalogue-1', the engine's opt-in catalogue hardware
     policy (dimmer at exactly 5 m, outdoor above 12 m, uncapped sections -
     see the engine header). The creator never sets it, so creator prices
     are untouched.
   - parts.width: what the customer is told, from the EXACT physical width
     (Jack, 25 Sep): over 1100 mm = 'two' parts; over 2200 mm = 'multiple'
     parts (no count is promised); 1100 mm exactly is one piece and 2200 mm
     exactly is two. US widths are exact inches, so 43 in (1092.2 mm) is one
     piece, 44 in two parts, 86 in two parts, 87 in multiple. The engine's
     own cut plan (sections across AND down, for the factory) is unchanged
     and is reported beside it (parts.across / parts.down).
   - tubing.measurement passes the record's evidence grade through (A / B / R,
     registry 1.4.0 - image-derived estimates, see its header) so the quote,
     the order and the factory record say how the length was obtained. A
     record without an eligible grade is refused, never priced
     (evidence_grade_missing). 'M' is kept for a manufacturer-stated length
     stored on the product itself.
   - uvPrint: true when the design's artwork is UV printed (registry 1.4.0
     production.uvPrint - printed fills seen on the product photos on review,
     or UV Print on the manufacturing records). The engine's catalogue-1
     policy then costs the matrix UV print rate on the board area.
   The measurement method notes below describe 1.0.x; the current method is
   in the registry header (tnf-cat-registry-1-4-0.js).
   --------------------------------------------------------------------------
   ISOLATED, VERSIONED INTEGRATION with the creator workstream.
   It does NOT modify, fork or replace any tnf-geometry-* / tnf-pricing-*
   file. It presents the SAME interface the creator's pricing engine already
   consumes (TNF_GEOM.geometry(cfg) -> geometry object), so the catalogue is
   priced by the creator's approved engine, unchanged.

   Pinned dependency: tnf-pricing-2-6-7.js (1.1.0; 1.0.x pinned 2.6.6, which
   2.6.7 reproduces exactly for any geometry without a hardware policy)

   1.0.1 (2026-09-23): the caller may pass cfg.height_mm - the board height
   already quantised to the manufacturing grid by the buy box. When present
   it IS the board height the engine prices, so the price, the preview and
   the factory record describe one sign. Absent, the raw ratio is used as
   before. Nothing else changed.

   WHY A DIFFERENT GEOMETRY SOURCE
   The creator derives tubing from wording + font + glyph metrics. A catalogue
   design is fixed artwork: there is no wording to re-set and the font is not
   recorded on the product. Tubing is therefore MEASURED from the design's own
   artwork, once, and scaled with width.

   THE MEASUREMENT (per design, recorded in catalogue-geometry.json)
     1. threshold the lit tube in the product render
     2. skeletonise it -> centreline length in pixels
     3. scale with the product's OWN stated dimensions, via the engine's
        cut-to-shape board model (board = ink + 2 x 0.11 x ink_height)
     4. cross-check: the implied board width must reproduce the product's
        stated width, and the implied tube diameter must land on 6 or 8 mm
   A design that fails either cross-check is NOT priced. It is listed as
   missing geometry, with the exact failing input.

   SCALING. A catalogue customer resizes a fixed design, so the scale is
   uniform: tubing scales LINEARLY with width, board dimensions scale
   linearly, board AREA scales with the square. Tube diameter does not scale.
   ========================================================================== */
(function (root) {
  'use strict';

  var MM_PER_INCH = 25.4;
  var BOARD_MARGIN_FACTOR = 0.11;   // engine's cut_to_shape rule, unchanged
  /* 1.1.0: the evidence grades that may be priced (registry 1.4.0 header): A, B and R image-derived estimates and M, a
     manufacturer-stated length stored on the product - the same list as the product page and the order service */
  var ELIGIBLE_GRADES = ['A', 'B', 'R', 'E', 'M', 'P'];   /* 1.2.0: + E (manually corrected trace, m4 review); 1.5.0: + P (size records) */
  var MAX_HEIGHT_MM = 2400;                                /* 1.5.0: neither width nor height over 240 cm */
  /* 1.5.0: a grade P design is priced from its size records; its cost-model estimate is never a measured length */
  function isRecords(d) {
    var p = d && d.pricing;
    return !!(d && d.evidence && d.evidence.grade === 'P' && p && p.basis === 'records' &&
              p.AU && p.AU.length && p.US && p.US.length && d.costModel_m_at_ref > 0);
  }

  /* 1.3.0: THE packing plan (see header). Exact comparisons on the physical board, no rounding. */
  var ONE_PIECE_MM = 1100, TWO_PART_LONGEST_UNDER_MM = 1500;
  var WORDING = {
    two: { notice: 'Your sign will be made in two sections for delivery. These sections can be packed together in one package.',
           line: 'Made in two sections, packed together in one package' },
    sections: { notice: 'Your sign will be made in sections for delivery.', line: 'Made in sections for delivery' }
  };
  function catalogueParts(w, h) {
    var E = 1e-6, out;
    if (w <= ONE_PIECE_MM + E && h <= ONE_PIECE_MM + E) {
      out = { key: 'one', divided: false, pieces: 1, across: 1, down: 1 };
    } else {
      var longest = Math.max(w, h);
      if (longest < TWO_PART_LONGEST_UNDER_MM - E) {
        var acrossCut = w >= h;              /* cut across the longer side: each half is (longest / 2) x shortest */
        out = { key: 'two', divided: true, pieces: 2, across: acrossCut ? 2 : 1, down: acrossCut ? 1 : 2 };
      } else {
        var nx = w > ONE_PIECE_MM + E ? Math.ceil(w / ONE_PIECE_MM - 1e-9) : 1;
        var ny = h > ONE_PIECE_MM + E ? Math.ceil(h / ONE_PIECE_MM - 1e-9) : 1;
        out = { key: 'sections', divided: true, pieces: nx * ny, across: nx, down: ny };
      }
    }
    out.section_mm = [Math.round(w / out.across * 10) / 10, Math.round(h / out.down * 10) / 10];
    out.packedTogether = out.key === 'two';
    out.notice = out.divided ? WORDING[out.key].notice : null;
    out.line = out.divided ? WORDING[out.key].line : null;
    out.rule = { onePiece_mm: ONE_PIECE_MM, twoPartLongestUnder_mm: TWO_PART_LONGEST_UNDER_MM,
                 source: 'creator packing (one piece within 110 cm; wording 2.5.10); manufacturer 23 Sep 2026: two pieces under 150 cm' };
    return out;
  }

  var LIMITS = { AU: { unit: 'cm', step_mm: 10,         maxWidth_mm: 4800 },
                 US: { unit: 'in', step_mm: MM_PER_INCH, maxWidth_mm: 188 * MM_PER_INCH } };

  /* registry is injected by the theme (window.TNF_CAT_DESIGNS) */
  function design(handle) {
    var R = root.TNF_CAT_DESIGNS || {};
    return R[handle] || null;
  }

  function geometry(cfg) {
    var market = cfg.market === 'US' ? 'US' : 'AU';
    var d = cfg.design || design(cfg.handle);
    if (!d) return { ok: false, reason: 'no_catalogue_geometry', market: market, unsupported: [] };
    /* 1.5.0: a grade P design prices from its records; the cost model scales its estimate like any length */
    var records = isRecords(d);
    var tubeRef = records ? d.costModel_m_at_ref : d.tubing_m_at_ref;
    if (!tubeRef || !d.refWidth_mm)
      return { ok: false, reason: 'geometry_incomplete', market: market, unsupported: [] };
    /* 1.1.0: one eligibility policy - only a graded measurement is priced (1.5.0: or a grade P design with its records) */
    var grade = d.evidence && d.evidence.grade;
    if (ELIGIBLE_GRADES.indexOf(grade) < 0 || (grade === 'P' && !records))
      return { ok: false, reason: 'evidence_grade_missing', market: market, unsupported: [] };

    var w = Number(cfg.width_mm);
    if (!isFinite(w) || w <= 0) return { ok: false, reason: 'bad_width', market: market, unsupported: [] };

    var k = w / d.refWidth_mm;                      // uniform scale factor
    var board_w = w;
    var hq = Number(cfg.height_mm);
    var board_h = (isFinite(hq) && hq > 0) ? hq : d.refHeight_mm * k;
    var ink_h   = d.refInkHeight_mm * k;
    var L_m     = tubeRef * k;

    var flags = [], blocking = [];
    if (w < d.minWidth_mm - 1e-6) { flags.push('below_minimum_width'); blocking.push('below_minimum_width'); }
    if (w > d.maxWidth_mm + 1e-6) { flags.push('above_product_maximum'); blocking.push('above_product_maximum'); }
    if (w > LIMITS[market].maxWidth_mm) { flags.push('above_market_maximum'); blocking.push('above_market_maximum'); }
    /* 1.5.0: the height limit (the width range already stops where the height reaches it) */
    if (board_h > MAX_HEIGHT_MM + 1e-6) { flags.push('above_product_maximum_height'); blocking.push('above_product_maximum'); }

    /* 1.2.0: one plan (see header) */
    var parts = catalogueParts(board_w, board_h);
    var divided = parts.divided;
    if (divided) flags.push('divided_into_sections_over_110cm');

    return {
      ok: blocking.length === 0,
      reason: blocking[0] || undefined,
      market: market,
      version: '1.5.0-cat',
      source: records ? 'catalogue size records (grade P pricing policy)' : 'catalogue artwork measurement',
      pricing: records ? d.pricing : null,
      design: d.handle,
      hardwarePolicy: 'catalogue-2',
      uvPrint: !!(d.production && d.production.uvPrint),
      font: null, fontDisplay: d.artworkName || d.handle,
      /* the engine only reads fontClass for the Premium RGB add-on table.
         A catalogue design has no font, so RGB is NOT auto-priced here -
         it is blocked and referred, rather than guessed onto a font class. */
      fontClass: d.fontClass || null,
      construction: d.construction || 'fixed artwork',
      constructionKey: 'catalogue',
      tube_mm: d.tube_mm || 6,
      tubeConfirmed: !!d.tubeConfirmed,
      lineCount: d.lineCount || 1,
      unsupported: [],
      board: { w_mm: board_w, h_mm: board_h, depth_mm: 20,
               margin_mm: BOARD_MARGIN_FACTOR * ink_h,
               style: cfg.backboard || d.boardStyle || 'cut_to_shape',
               proposed: false, role: 'acrylic backboard',
               marginBasis: 'measured from the product artwork and its stated dimensions' },
      runs: null, outline: null,
      envelope: { w_mm: board_w - 2 * BOARD_MARGIN_FACTOR * ink_h, h_mm: ink_h },
      ink:      { w_mm: board_w - 2 * BOARD_MARGIN_FACTOR * ink_h, h_mm: ink_h },
      overall:  { w_mm: board_w, h_mm: board_h, depth_mm: 20 },
      stand: null, box: null,
      tubing: records
        ? { L_m: Math.round(L_m * 1000) / 1000, symbols_m: 0,
            model: 'cost-model estimate only - the price comes from the product size records (grade P); not a measured length',
            construction: 'fixed artwork', confirmed: false, measurement: null,
            costModel: { refWidth_mm: d.refWidth_mm, refHeight_mm: d.refHeight_mm, estimate_m_at_ref: d.costModel_m_at_ref, grade: 'P',
                         use: 'growth above the largest recorded size and the outdoor ratio only' } }
        : { L_m: Math.round(L_m * 1000) / 1000, symbols_m: 0,
                model: 'artwork-centreline-measured', construction: 'fixed artwork',
                confirmed: false,
                measurement: { refWidth_mm: d.refWidth_mm, refHeight_mm: d.refHeight_mm,
                               tubing_m_at_ref: d.tubing_m_at_ref, grade: grade,
                               gradeLabel: (d.evidence && d.evidence.label) || null,
                               manufacturerVerified: !!(d.evidence && d.evidence.manufacturer_verified),
                               method: d.method, checks: d.checks } },
      minimum: { width_mm: d.minWidth_mm, widthStep_mm: d.minWidth_mm,
                 basis: d.minBasis || 'smallest size this design is already sold at',
                 confirmed: !!d.minConfirmed },
      letterHeight_mm: ink_h,
      letterHeightPerTube: ink_h / (d.tube_mm || 6),
      panels: 1, packagingConfirmed: false, symbolCount: 0,
      flags: flags,
      parts: parts
    };
  }

  function roundUpToStep(mm, market) {
    var s = LIMITS[market === 'US' ? 'US' : 'AU'].step_mm;
    return Math.ceil(mm / s - 1e-9) * s;
  }
  function roundDownToStep(mm, market) {
    var s = LIMITS[market === 'US' ? 'US' : 'AU'].step_mm;
    return Math.floor(mm / s + 1e-9) * s;
  }


  var API = { version: '1.5.0', MM_PER_INCH: MM_PER_INCH, LIMITS: LIMITS, MAX_HEIGHT_MM: MAX_HEIGHT_MM, isRecords: isRecords,
              BOARD_MARGIN_FACTOR: BOARD_MARGIN_FACTOR, ELIGIBLE_GRADES: ELIGIBLE_GRADES,
              geometry: geometry, design: design, catalogueParts: catalogueParts, PACKING_WORDING: WORDING,
              roundUpToStep: roundUpToStep, roundDownToStep: roundDownToStep,
              pricingEngine: '2.6.8', hardwarePolicy: 'catalogue-2' };
  root.TNF_CAT_GEOM = API;
  if (typeof module !== 'undefined' && module.exports) module.exports = API;
})(typeof window !== 'undefined' ? window : globalThis);
